const SINGLE_LINE_TOGGLE_CLASSNAME = 'single-line-toggle';
const IS_FOLDED_MODIFIER = '--is-folded';

const DEFAULT_OPTIONS = {
    singleLingeToggleClassName: SINGLE_LINE_TOGGLE_CLASSNAME,
    isFoldedClassName: SINGLE_LINE_TOGGLE_CLASSNAME + IS_FOLDED_MODIFIER
};

class SingleLineToggle {
    constructor($element, options) {
        this.options = {...DEFAULT_OPTIONS, ...options};
        this.$element = $element;

        $element.addClass([this.options.singleLingeToggleClassName, this.options.isFoldedClassName].join(' '));
        this.registerEvents();
    }

    registerEvents() {
        this.$element.on('click', () => {
            this.$element.toggleClass(this.options.isFoldedClassName);
        });
    }
}

($ => {
    $.fn.singleLineToggle = function() {
        return this.each(function () {
            new SingleLineToggle($(this));
        });
    };
})(jQuery);

export default SingleLineToggle;
